<template lang="pug">
  .wt-tile.tile(:class="classArray()")
    BLoading(:is-full-page="false" :active.sync="isLoading")
      .is-syncing-loader.has-text-weight-bold.is-size-1(v-show="isSyncing") Syncing...
    <!-- @slot Use this slot for tile content -->
    slot
</template>

<script>
const BULMA_CLASS_PREFIX = "is-";

/**
 * Based on Bulmas Tile element
 *
 * https://bulma.io/documentation/layout/tiles/
 */
export default {
  name: "WtTile",

  props: {
    isLoading: {
      type: Boolean,
      default: false
    },

    /**
     * prop to trigger BLoading slot to replace default loading-spinner with "Syncing..." text
     */
    isSyncing: {
      type: Boolean,
      default: false
    },

    ancestor: {
      type: Boolean,
      default: false
    },

    parent: {
      type: Boolean,
      default: false
    },

    child: {
      type: Boolean,
      default: false
    },

    vertical: {
      type: Boolean,
      default: false
    },

    col: {
      type: Number,
      default: 0
    },

    childClass: {
      type: String,
      default: "box"
    },

    bordered: {
      type: Boolean,
      default: false
    },

    /**
     * `small`, `large`
     */
    padding: {
      type: String,
      default: ""
    }
  },

  methods: {
    classArray() {
      return [
        this.contextualModifier(),
        this.directionModifier(),
        this.sizeModifier(),
        this.shadowClass(),
        this.borderClass(),
        this.paddingClass()
      ];
    },

    contextualModifier() {
      let contextModifier = BULMA_CLASS_PREFIX;

      if (this.ancestor) {
        contextModifier += "ancestor";
      } else if (this.parent) {
        contextModifier += "parent";
      } else if (this.child) {
        contextModifier += "child";
      } else {
        contextModifier = "";
      }

      return contextModifier;
    },

    directionModifier() {
      let direction = "";

      if (this.vertical) {
        direction = `${BULMA_CLASS_PREFIX}vertical`;
      }

      return direction;
    },

    sizeModifier() {
      return this.col ? `${BULMA_CLASS_PREFIX}${this.col}` : "";
    },

    /**
     * will get applied if child is true
     */
    shadowClass() {
      return this.child ? this.childClass : "";
    },

    borderClass() {
      return this.bordered ? "bordered" : "";
    },

    paddingClass() {
      return this.padding ? `pad-${this.padding}` : "";
    }
  }
};
</script>

<style lang="sass">
.wt-tile
  position: relative
  .bordered
    box-shadow: none !important
    border: 1px solid $grey-light
    border-radius: $radius !important

  .pad-small
    padding: 0.9rem

  .pad-large
    padding: 1.1rem
</style>
